import React, { useContext, useEffect } from 'react';
import styles from '../Components/Details.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { height } from '@fortawesome/free-solid-svg-icons/fa0';
import customButton from '../css/Button.module.css';
import { Usercontext } from '../App';

const Details = () => {
  const navigate = useNavigate();
  const {userdata} =  useContext(Usercontext)
  const location = useLocation();
  const { name, size, imageURL, feature, segment, desc,id } = location.state || {};

  useEffect(() => {
    if (location.state === null) {
      console.log("Redirecting to home page");
      navigate('/', { replace: true });
    }
  }, [location.state, navigate]);

  const handleOrders = () => {

    userdata?.isAdmin 
    ?
      navigate('/edit',{replace : true,state : {id,name,size,segment,feature,desc}}) 
    : 
      navigate('/orders', {replace:true,state:{id,name,size,segment}})
  }

  // Define the carousel items based on imageURL
  const carouselItems = imageURL?.map((url, index) => (
    <div className={`carousel-item ${index === 0 ? 'active' : ''}`} key={index}>
      <img
        className={`d-block w-100 ${styles.img_config}`}
        // style={{minHeight:'555px', minWidth:'391px'}}
        src={(`/Images/${segment || "Primer"}/${url}`)}
        alt={`Slide ${index + 1}`}
      />
    </div>
  ));

  return (
    <div className={styles.container}>
      <div className={styles.leftSide}>
      {/* <div className={styles.imagecontainer}> */}
        <div id="carouselExampleControls" className="carousel slide" data-ride="carousel">
          <div className="carousel-inner">
            {carouselItems}
          </div>
          <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </a>
          <a className="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </a>
        </div>
      {/* </div> */}
      </div>
      <div className={styles.rightSide}>
        <h1 className={styles.productName}>{name || ""}</h1>
        <div className={styles.features}>
          {feature?.map((featureItem, index) => (
            <div className={styles['feature-inner-main']} key={index}>
              <img
                className={styles['feature-img']}
                src={(`/Images/Features/${featureItem}.png`)}
                alt={featureItem}
              />
              <p className={styles['card-p']}>{featureItem}</p>
            </div>
          ))}
        </div>
        <div className={styles.sizes}>
          <img src={('/Images/Features/paintbucket.png')} alt='BUCKET' style={{ height: '60px', width: '60px' }} />
          {size?.map((sizeItem, index) => (
            <div
              key={index}
              className={styles.sizeBox}
            >
              {sizeItem.capacity}
            </div>
          ))}
        </div>
        <div className={styles.description}>
          <p>{desc || ""}</p>
        </div>
        <div>
        <button className={customButton.button} onClick={handleOrders} style={{ background: '#06bdf6', width: '100%' }}>{userdata?.isAdmin ? 'Edit' : 'Buy Now'}</button>
        </div>
      </div>
    </div>
  );
};

export default Details;
